import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { RELEASE_CHANNEL, RELEASE_NOTE } from '../constants/release';

/**
 * Public Beta Footer
 * Displays on public/marketing pages only — hidden when logged in to avoid extra scrollbar
 */
const PublicBetaFooter = () => {
  const { user } = useAuth();

  // Hide on authenticated pages
  if (user) return null;

  return (
    <footer className="w-full py-4 px-6 bg-[#161B26] border-t border-[#2D2E3A]">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-2 text-sm text-[#718096]">
          <div className="flex items-center gap-2 flex-wrap justify-center md:justify-start">
            <span className="font-medium text-white">Man & Machine</span>
            <span>·</span>
            <span className="text-[#00E5C0]">{RELEASE_CHANNEL}</span>
            <span className="hidden sm:inline">·</span>
            <Link 
              to="/feedback" 
              className="text-[#00E5C0] hover:text-[#00D4B0] transition-colors underline"
            >
              Give feedback
            </Link>
          </div>
          <div className="text-center md:text-right">
            <span>{RELEASE_NOTE}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicBetaFooter;
